const beforeAfterPlayControlsTemplate = ({playButtonIndex, playIndex, accessBtnClickToPlay, replayButtonIndex, replayIndex, accessBtnClickToReplay}) => `<div class="video-click-to-play-link" tabindex="${playButtonIndex}">
    <button type="button" class="video-click-to-play ui play-button-overlay-glyph" tabindex="${playIndex}" aria-label="${accessBtnClickToPlay}" data-cy="video-click-to-play"></button>
</div>
<div class="video-click-to-replay-link" tabindex="${replayButtonIndex}">
    <button type="button" class="video-click-to-replay ui replay-button-overlay-glyph" tabindex="${replayIndex}" aria-label="${accessBtnClickToReplay}"></button>
</div>
<div class="before-after-plugin-container"></div>`;

export default beforeAfterPlayControlsTemplate;
